import { Box, Typography } from "@mui/material";
import React from "react";
import PerformanceChart from "./PerformanceChart";
import { formatWebNumbers } from "../../utils/helper";

const PerformanceGraphs = ({ dashboardData }) => {
  const averageContractLength =
    dashboardData?.totalContractLength / dashboardData?.totalContracts;

  return (
    <Box
      mt={5}
      p={2.5}
      borderRadius={3}
      boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"}
    >
      {/*
        Removed by client

      <Typography
        variant="body2"
        color={"secondary.dark"}
        fontWeight={500}
        fontSize={"1.25rem"}
      >
        Performance Graphs
      </Typography>

      <Typography variant="body1" color={"secondary.greyChateau"}>
        Contracts Signed:{" "}
        <span style={{ color: "black" }}>
          {dashboardData?.totalSignedContracts || 0}
        </span>
      </Typography>
      <Typography variant="body1" color={"secondary.greyChateau"}>
        Gross Profit:{" "}
        <span style={{ color: "black" }}>
          £{dashboardData?.totalProfit || 0}
        </span>
      </Typography> */}

      <Typography variant="h6" fontWeight={600}>
        Future Live:{" "}
        <span style={{ color: "black" }}>
          {formatWebNumbers(dashboardData?.futureLive) || 0}
        </span>
      </Typography>
      <Typography variant="h6" fontWeight={600}>
        Average Contract Length:{" "}
        <span style={{ color: "black" }}>
          {formatWebNumbers(averageContractLength) || 0}
        </span>
      </Typography>
      <Typography variant="h6" fontWeight={600}>
        SPD:{" "}
        <span style={{ color: "black" }}>
          {isNaN(dashboardData?.spd) ? "0" : dashboardData?.spd || "0"}
        </span>
      </Typography>
      {/* {dashboardData?.chartData?.length > 0 ? (
        <PerformanceChart chartData={dashboardData?.chartData} />
      ) : (
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2rem" }}
          textAlign={"center"}
          my={3}
        >
          No Graph Data Found
        </Typography>
      )} */}
    </Box>
  );
};

export default PerformanceGraphs;
